let slideshowControllers = []

const SLIDESHOW_INTERVAL = 5000
const mobileAutoscrollQuery = window.matchMedia('(max-width: 800px)')
const SHARE_STATUS_TIMEOUT = 3000

const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches

const setShareStatus = (status, message) => {
    if (!status) return

    status.textContent = message

    window.clearTimeout(status.galleryShareTimeout)
    status.galleryShareTimeout = window.setTimeout(() => {
        status.textContent = ''
    }, SHARE_STATUS_TIMEOUT)
}

const fallbackCopyToClipboard = text => {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'fixed'
    textarea.style.top = '-9999px'
    textarea.style.left = '-9999px'

    document.body.appendChild(textarea)
    textarea.select()
    textarea.setSelectionRange(0, textarea.value.length)

    const copied = document.execCommand('copy')
    document.body.removeChild(textarea)

    if (!copied) {
        throw new Error('Copy command failed')
    }
}

const copyToClipboard = async text => {
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text)
        return
    }

    fallbackCopyToClipboard(text)
}

const setSlideshowIndex = (slideshow, index) => {
    const slides = Array.from(slideshow.querySelectorAll('[data-gallery-slide]'))
    slideshow.style.setProperty('--gallery-slide-index', index)

    slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index
        slide.classList.toggle('is-active', isActive)
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true')
    })
}

const destroyGallerySlideshows = () => {
    slideshowControllers.forEach(({ intervalId, cleanup }) => {
        clearInterval(intervalId)
        cleanup()
    })
    slideshowControllers = []
}

const initGallerySlideshows = () => {
    destroyGallerySlideshows()

    if (prefersReducedMotion()) return

    document.querySelectorAll('[data-gallery-slideshow]').forEach(slideshow => {
        const slides = Array.from(slideshow.querySelectorAll('[data-gallery-slide]'))
        const isPausedByCms = slideshow.dataset.galleryAutoscrollPaused === 'true'
        const isPausedOnMobile = mobileAutoscrollQuery.matches

        setSlideshowIndex(slideshow, 0)

        if (isPausedByCms || isPausedOnMobile || slides.length <= 1) return

        let currentIndex = 0
        let isInteractionPaused = false

        const advance = () => {
            if (isInteractionPaused) return

            currentIndex = (currentIndex + 1) % slides.length
            setSlideshowIndex(slideshow, currentIndex)
        }

        const intervalId = setInterval(advance, SLIDESHOW_INTERVAL)
        const pause = () => {
            isInteractionPaused = true
        }
        const resume = () => {
            isInteractionPaused = false
        }

        slideshow.addEventListener('mouseenter', pause)
        slideshow.addEventListener('mouseleave', resume)
        slideshow.addEventListener('focusin', pause)
        slideshow.addEventListener('focusout', resume)

        slideshowControllers.push({
            intervalId,
            cleanup: () => {
                slideshow.removeEventListener('mouseenter', pause)
                slideshow.removeEventListener('mouseleave', resume)
                slideshow.removeEventListener('focusin', pause)
                slideshow.removeEventListener('focusout', resume)
            },
        })
    })
}

const initGalleryShareButtons = () => {
    document.querySelectorAll('[data-gallery-share]').forEach(button => {
        if (button.dataset.galleryShareInitialized === 'true') return

        button.dataset.galleryShareInitialized = 'true'

        button.addEventListener('click', async () => {
            const gallery = button.closest('[data-product-gallery]')
            const status = gallery?.querySelector('[data-gallery-share-status]')
            const currentUrl = window.location.href

            try {
                await copyToClipboard(currentUrl)
                setShareStatus(status, 'Link copied')
            } catch (error) {
                setShareStatus(status, 'Unable to copy link')
            }
        })
    })
}

const handleGalleryFilterKeydown = event => {
    if (event.key !== 'Enter') return
    if (!event.target.matches('.product-gallery-filter input[type="checkbox"]')) return

    event.preventDefault()
    event.target.click()
}

const initProductGallery = () => {
    initGallerySlideshows()
    initGalleryShareButtons()
}

document.addEventListener('keydown', handleGalleryFilterKeydown)
document.addEventListener('htmx:afterSwap', initProductGallery)
document.addEventListener('DOMContentLoaded', initProductGallery)

const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
if (reducedMotionQuery.addEventListener) {
    reducedMotionQuery.addEventListener('change', initGallerySlideshows)
} else if (reducedMotionQuery.addListener) {
    reducedMotionQuery.addListener(initGallerySlideshows)
}

if (mobileAutoscrollQuery.addEventListener) {
    mobileAutoscrollQuery.addEventListener('change', initGallerySlideshows)
} else if (mobileAutoscrollQuery.addListener) {
    mobileAutoscrollQuery.addListener(initGallerySlideshows)
}
